<template>
  <div>
    <!-- Modal -->
    <div 
      class="modal fade" 
      id="modalAccessoriesUnmatch" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="unmatchModalLabel" 
      aria-hidden="true"
      ref="modal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header border-bottom">
            <h5 class="modal-title font-weight-bold" id="unmatchModalLabel">
              Unmatch Accessories
            </h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body" v-if="orderData.dataAccessories && !orderData.dataAccessories.batchNo">
            <div class="p-3 bg-light rounded mb-2">
              <!-- Company Info -->
              <div class="row mb-3">
                <div class="col-4">
                  <strong>Company Info:</strong>
                </div>
                <div class="col-8" style="text-align: right;">
                  {{orderData.companyName}}
                </div>
              </div>

              <!-- Order ID -->
              <div class="row mb-1">
                <div class="col-4">
                  <strong>Order ID:</strong>
                </div>
                <div class="col-8" style="text-align: right;">
                  <div v-if="orderData.orderCode" class="text-primary" style="cursor: pointer;" @click="toOrderDetail(orderData.orderId, orderData.orderCode,orderData.companyId)">{{orderData.orderCode}}</div>
                  <!-- <a :href="orderInfo.link" class="text-primary">
                    {{ orderData.co }}
                  </a> -->
                </div>
              </div>
            </div>

            <!-- Accessories -->
            <div class="p-3 bg-light rounded mb-3">
              <div class="row mb-2">
                <div class="col-4">
                  <strong>Accessories:</strong>
                </div>
                <div class="col-8" style="text-align: right;">
                  {{ orderData.dataAccessories ? orderData.dataAccessories.itemName : '' }}
                </div>
              </div>

              <!-- Total Units -->
              <div class="row mb-1">
                <div class="col-4">
                  <strong>Total Units:</strong>
                </div>
                <div class="col-8" style="text-align: right;">
                  {{ orderData.totalQty}} {{ orderData.totalQty == 1 ? 'unit' : 'units'}}
                </div>
              </div>
            </div>

            <!-- Number of Unmatched Units -->
            <div class="d-flex align-items-center mb-1 border-card" style="justify-content: space-between;">
              <div class="mb-0 mr-3" style="font-size: 1rem; font-weight: 600;">Number of Unmatched Units</div>
              <div class="d-flex align-items-center" style="justify-content: space-between;">
                  <div>
                    <button 
                      class="btn btn-light border mr-1 btn-qty"
                      @click="decrementUnits"
                      :disabled="unmatchedUnits == 1"
                    >
                      −
                    </button>
                  </div>

                  <div>
                    <input 
                      type="number" 
                      class="form-control text-center no-spinner" 
                      v-model.number="unmatchedUnits"
                      :min="1"
                      :max="orderData.totalQty"
                    >
                  </div>
                  <div>
                    <button 
                      class="btn btn-light border ml-1 btn-qty"
                      @click="incrementUnits"
                      :disabled="unmatchedUnits >= orderData.totalQty"
                    >
                      +
                    </button>
                  </div>
              </div>
            </div>

              <!-- Warning Message -->
            <div class="alert alert-warning d-flex align-items-start mb-0" role="alert">
                <i class="fas fa-exclamation-circle mt-1 mr-2"></i>
                <small>Specify the quantity of accessories that do not match.</small>
            </div>
       
          </div>

          <div class="modal-body" v-else>
            <!-- Order Info -->
            <div class="mb-3">
              <h6 class="section-label">Order Info</h6>
              <div class="info-card">
                <div class="mb-1 font-weight-600">{{ orderData.companyName }}</div>
                <div 
                  v-if="orderData.orderCode" 
                  class="text-primary" 
                  style="cursor: pointer;" 
                  @click="toOrderDetail(orderData.orderId, orderData.orderCode, orderData.companyId)"
                >
                  {{ orderData.orderCode }}
                </div>
              </div>
            </div>

            <div class="mb-3" >
              <h6 class="section-label">Product Info</h6>
              <div class="info-card">
                <div class="text-muted small mb-1">Accessories</div>
                <div class="font-weight-600 mb-3">
                  {{ orderData.dataAccessories ? orderData.dataAccessories.itemName : '-' }}
                </div>
                <div class="row">
                  <div class="col-6 mb-2">
                    <div class="detail-label">Product Code</div>
                    <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.itemCode || '-' : '-' }}</div>
                  </div>
                  <div class="col-6 mb-2">
                    <div class="detail-label">Serial Number</div>
                    <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.serialNumber || '-' : '-' }}</div>
                  </div>
                  <div class="col-6">
                    <div class="detail-label">Stock Code</div>
                    <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.stockCode || '-' : '-' }}</div>
                  </div>
                  <div class="col-6">
                    <div class="detail-label">Batch Number</div>
                    <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.batchNumber || '-' : '-' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Number of Accessories Unmatched -->
            <div class="unmatch-summary-card">
              <div class="unmatch-label">Number of Accessories Unmatched</div>
              <div class="unmatch-value">{{ unmatchedUnits }} {{ unmatchedUnits == 1 ? 'unit' : 'units' }}</div>
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="modal-footer border-top">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button 
              type="button" 
              class="btn btn-primary text-white" 
              @click="confirmUnmatch"
            >
              Confirm Unmatch
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: 'ModalAccessoriesUnmatch',
  props: ['orderData','toOrderDetail'],
  data() {
    return {
      unmatchedUnits: 1,
    }
  },
  methods: {
    showModal() {
      // Reset unmatched units ketika modal dibuka
      this.unmatchedUnits = 1;
      $(this.$refs.modal).modal('show');
    },
    closeModal() {
      $(this.$refs.modal).modal('hide');
    },
    incrementUnits() {
      // if (this.unmatchedUnits < this.orderData.dataAccessories.qty) {
        this.unmatchedUnits++;
      // }
    },
    decrementUnits() {
      // if (this.unmatchedUnits > 1) {
        this.unmatchedUnits--;
      // }
    },
    confirmUnmatch() {
      // Validasi
      if (this.unmatchedUnits < 1 || this.unmatchedUnits > this.orderData.dataAccessories.qty) {
        alert(`Jumlah unmatch harus antara 1 dan ${this.orderData.dataAccessories.qty}`);
        return;
      }

      const {orderId, dataAccessories} = this.orderData
      const {itemCode, itemGroup, itemName, batchNo} = dataAccessories
      const payload = {
        orderId,
        itemCode,
        itemGroup,
        itemName,
        qty: this.unmatchedUnits,
        batchNo,
      }
      // console.log(payload)
      this.processAccessoriesQcUnmatch(payload)
      this.closeModal();
    },
    processAccessoriesQcUnmatch(payload) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.post(process.env.QC_UNMATCH_ACCESSORIES, payload, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: `Data has been saved successfully.`,
              icon: "success",
            }).then(result => {
              this.closeModal()
              window.location.reload()
            })
          } else {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: `${res.data.message}`,
              icon: "error",
            })
          }
        })
        .catch(error => {
          this.loadingTable = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: `${error.response.data.message}`,
            icon: "error",
          })
        })
    },
  },
  watch: {
    unmatchedUnits(newVal) {
      // Pastikan nilai selalu dalam range yang valid
       if (newVal < 1) {
        this.unmatchedUnits = 1;
      } else if (newVal > this.orderData.totalQty) {
        this.unmatchedUnits = this.orderData.totalQty;
      }
    }
  }
}
</script>

<style scoped>
.section-label {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #212529;
}
.info-card {
  border: 1px solid #D1D9E2;
  border-radius: 6px;
  padding: 0.875rem 1rem;
  background-color: #fff;
}
.font-weight-600 {
  font-weight: 600;
}
.detail-label {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 2px;
}
.detail-value {
  font-size: 13px;
  color: #212529;
}

.unmatch-summary-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFBEB;
  border: 1px solid #FDE68A;
  border-radius: 6px;
  padding: 0.75rem 1rem;
}
.unmatch-label {
  font-size: 14px;
  font-weight: 600;
  color: #92400E;
}
.unmatch-value {
  font-size: 14px;
  font-weight: 600;
  color: #92400E;
}
/* Untuk Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Untuk Firefox */
.no-spinner[type=number] {
  -moz-appearance: textfield;
}
.btn-qty {
  width: 38px;
  height: 38px;
  font-size: 18px;
  padding: 0;
  line-height: 1;
}
.border-card {
  border: 1px solid  #CFD3D9;
  border-radius: 8px;
  padding: 10px;
}
.modal-header {
  background-color: #fff;
  padding: 1rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.font-weight-bold {
  font-weight: 600;
}

.input-group .btn {
  border-color: #ced4da;
  width: 45px;
}

.input-group .form-control {
  border-left: 0;
  border-right: 0;
}

.input-group-prepend .btn,
.input-group-append .btn {
  z-index: 0;
}

.input-group .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.btn-warning {
  background-color: #ff7f32;
  border-color: #ff7f32;
}

.btn-warning:hover {
  background-color: #e67329;
  border-color: #e67329;
}

.btn-warning:disabled {
  background-color: #ff7f32;
  border-color: #ff7f32;
  opacity: 0.65;
}

hr {
  margin: 1rem 0;
  border-top: 1px solid #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/QC/CustomComponent/ModalAccessoriesUnmatch.vue